import type {Result, UseCase} from 'framework';
import type {SavedMealError} from '../../domain/errors';
import type {SavedMealId} from '../../domain/saved-meal-id.value-object';
import type {SavedMealRepository} from '../ports/saved-meal.repository';

export class TouchSavedMeal implements UseCase<[SavedMealId], void> {
  constructor(private readonly repository: SavedMealRepository) {}

  execute(id: SavedMealId): Promise<Result<void, SavedMealError>> {
    return this.repository.touch(id);
  }
}
